import script from "./step6ReadyForSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./step6ReadyForSelection.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__